import React, { Component } from 'react';
import { Table, Input, Button, Icon } from 'semantic-ui-react';
import { clone, applySnapshot, getSnapshot } from 'mobx-state-tree';
import { observer } from 'mobx-react';

class BomTableRow extends Component {
  state = {
    isEditing: false,
    clone: null
  }
  render() { 
    if (this.state.isEditing) return this.renderEditableRow()
    const { item } = this.props
    const perText = {
      each: 'each',
      metre: 'per metre',
      sheet: 'per sheet'
    }
    return (
      <Table.Row>
        <Table.Cell>{item.material}</Table.Cell>
        <Table.Cell positive={item.isUnitsRequiredEdited}>
          {item.unitsRequired} {this.pluralizeRequirements(item.units, item.unitsRequired)}
          {item.lengthsRequired > 0 &&
            <Icon name='info' title={item.lengthsRequired + (item.lengthsRequired === 1 ? ' length' : ' lengths')} />
          }
        </Table.Cell>
        <Table.Cell>${item.unitCost.toFixed(2)} {perText[item.units]}</Table.Cell>
        <Table.Cell>${item.extendedCost().toFixed(2)}</Table.Cell>
        {!this.props.noEdit &&
          <Table.Cell>
            <a href='#edit-bom-item' onClick={() => this.editItem(item)}>Edit</a>
          </Table.Cell>
        }
      </Table.Row>
    )
  }
  pluralizeRequirements(units, qty) {
    switch (units) {
      case 'sheet':
        return qty === 1 ? 'sheet' : 'sheets'
      case 'metre':
        return qty === 1 ? 'metre' : 'metres'
      case 'each':
      default:
        return 'of'
    }
  }
  renderEditableRow = () => (
    <Table.Row>
      <Table.Cell>{this.state.clone.material}</Table.Cell>
      <Table.Cell>
        <Input type='number' step='0.01' value={this.state.clone.unitsRequired} onChange={this.handleChangeUnitsRequired} />
      </Table.Cell>
      <Table.Cell>
        <Input type='number' step='0.01' value={this.state.clone.unitCost} />
      </Table.Cell>
      <Table.Cell>${this.state.clone.extendedCost()}</Table.Cell>
      <Table.Cell>
        <Button type='button' size='small' color='olive' onClick={this.applyChanges}>Done</Button>
        <Button type='button' size='small' color='orange'  onClick={this.cancelEditing}>Cancel</Button>
      </Table.Cell>
    </Table.Row>
  )
  editItem = item => {
    this.setState({ 
      isEditing: true,
      clone: clone(item)
    })
  }
  handleChangeUnitsRequired = event => {
    var parsedValue = parseFloat(event.target.value)
    if (!isNaN(parsedValue))
      this.state.clone.setUnitsRequired(parsedValue)
  }
  applyChanges = () => {
    applySnapshot(this.props.item, getSnapshot(this.state.clone))
    this.cancelEditing()
  }
  cancelEditing = () => {
    this.setState({
      isEditing: false,
      clone: null
    })
  }
}
 
export default observer(BomTableRow);


// WEBPACK FOOTER //
// ./src/components/jobs/EstimateMaterialTableRow.js